declare global {
  interface Window {
    opr: any
  }

  interface Navigator {
    brave: any
  }
}

const userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent

export default !!(typeof navigator !== 'undefined' &&
  navigator.vendor?.includes('Google') &&
  userAgent.includes('Chrome') &&
  !userAgent.includes('Edg') &&
  !navigator.brave &&
  !window.opr)
